import { Calendar, ChevronRight } from 'lucide-react';
import { Button } from '~/shared/components/buttons/Button';

export function GoalCard({
	title,
	definitionText,
	completeByDate,
	onGoalSelect,
	children
}: {
	title: string;
	definitionText: string;
	completeByDate?: Date;
	onGoalSelect?: () => void;
	children?: React.ReactNode;
}) {
	return (
		<div className="overflow-hidden rounded-xl border border-gray-200">
			<div className="flex flex-row items-center justify-between px-5 ">
				<div className="border-b border-gray-100 py-4 ">
					<p className="text-sm font-bold text-gray-900">{title}</p>
					<p className="mt-0.5 text-xs text-gray-500">{definitionText}</p>
				</div>
				{completeByDate && (
					<div className="flex items-center gap-3 rounded-lg bg-gray-50 p-3">
						<Calendar className="size-4 text-gray-500" />
						<span className="text-sm">Complete by date: {completeByDate.toLocaleDateString()}</span>
					</div>
				)}
				{onGoalSelect && <Button Icon={ChevronRight} intent="neutral" appearance="outline" onClick={() => onGoalSelect()} />}
			</div>
			{children}
		</div>
	);
}
